import { Link } from "react-router-dom";
import { channels, siteMeta } from "@/mocks/chigua";

export default function Footer() {
  return (
    <footer className="border-t border-secondary-200/70 bg-secondary-100/60 text-foreground-800">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-12">
          {/* 品牌区 */}
          <div className="lg:col-span-5">
            <Link to="/" className="inline-flex items-center gap-2.5" aria-label={siteMeta.brand}>
              <span className="grid h-9 w-9 place-items-center rounded-lg bg-primary-500 font-display-sc text-xl leading-none text-background-50">
                瓜
              </span>
              <span className="font-display-sc text-2xl text-foreground-950">{siteMeta.brand}</span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-6 text-foreground-600">
              把散落的线索收拢成完整叙事，只按公开材料整理内幕消息与内幕真相。不做主观猜测，不制造定论，帮你站在完整信息基础上，形成自己的判断。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-shield-check-line text-secondary-600" aria-hidden="true" />
              内容原则：只看公开材料 · 给信源分级 · 串联时间线 · 不下预设结论
            </div>
          </div>

          {/* 栏目 */}
          <div className="lg:col-span-3">
            <h4 className="text-sm font-bold uppercase tracking-wider text-foreground-800">内容栏目</h4>
            <ul className="mt-4 space-y-2.5">
              {channels.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/list/${c.slug}`}
                    className="inline-flex items-center gap-2 text-sm text-foreground-600 transition hover:text-primary-700"
                  >
                    <i className="ri-corner-down-right-line text-xs text-secondary-500" aria-hidden="true" />
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 站点 */}
          <div className="lg:col-span-2">
            <h4 className="text-sm font-bold uppercase tracking-wider text-foreground-800">站点导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/" className="text-foreground-600 transition hover:text-primary-700">首页</Link></li>
              <li><Link to="/about" className="text-foreground-600 transition hover:text-primary-700">关于我们</Link></li>
              <li><Link to="/contact" className="text-foreground-600 transition hover:text-primary-700">联系我们</Link></li>
              <li><Link to="/search" className="text-foreground-600 transition hover:text-primary-700">站内搜索</Link></li>
            </ul>
          </div>

          {/* 联系 */}
          <div className="lg:col-span-2">
            <h4 className="text-sm font-bold uppercase tracking-wider text-foreground-800">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-secondary-600" aria-hidden="true" />
                <a href={`mailto:${siteMeta.email}`} className="transition hover:text-primary-700" rel="nofollow">
                  {siteMeta.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-secondary-600" aria-hidden="true" />
                编辑部 7×12 值守
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-feedback-line text-secondary-600" aria-hidden="true" />
                欢迎公开线索与指正
              </li>
            </ul>
          </div>
        </div>

        <div className="hairline mt-10" />

        <div className="mt-6 flex flex-col items-center justify-between gap-3 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} {siteMeta.copyright} · 仅按公开材料整理娱乐资讯，内容仅供信息参考。</p>
          <div className="flex items-center gap-4">
            <a href="#" className="transition hover:text-primary-700" rel="nofollow">免责声明</a>
            <span className="text-foreground-300">|</span>
            <a href="#" className="transition hover:text-primary-700" rel="nofollow">内容合作</a>
          </div>
        </div>
      </div>
    </footer>
  );
}